import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';

export default {
  name: 'customerAttachements',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users],
  props: {
    custkey: {
      type: String
    },
    propertyId: {
      type: String
    },
    isRtl: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      EnableEdit: false,
      Attachments: [],
      AttachmentsCols: [],

      attachmentsPageingOptions: { pageSize: 10, total: 0, page: 1 },
      attachmentsTotalRow: 0,
    }
  },
  created() {
    this.fillCols();
    this.getData();
  },
  methods: {
    getData() {

      if (this.custkey != null) {
        var parameters = {
          custkey: this.custkey,
          loginEmail: this.getLoginName(),
          Options: this.attachmentsPageingOptions
        }

        axios.post('/Enquiries/FillAttachments', parameters)
          .then(response => {
            if (response.status == 200) {

              this.EnableEdit = response.data.enableEdit;
              response.data.items.forEach(a => {
                let split = a.fileName.split('.');
                if (split && split.length > 0)
                  a['type'] = split[split.length - 1];
                else
                  a['type'] = '';
              })
              this.Attachments = response.data.items;
              this.attachmentsTotalRow = response.data.itemsCount;
            }
          })
          .catch(e => { return false; })
      }
      else if (this.propertyId != null) {
        var PropParameters = {
          propertyId: this.propertyId,
          loginEmail: this.getLoginName()
        }

        axios.post('/Enquiries/FillPropertyAttachments', PropParameters)
          .then(response => {
            if (response.status == 200) {

              console.log(response.data);

              this.EnableEdit = response.data.attchmentsData.enableEdit;
              this.Attachments = response.data.attchmentsData.attachments;
            }
          })
          .catch(e => { return false; })
      }
    },
    fillCols() {
      this.AttachmentsCols = [];
      this.AttachmentsCols.push({ dataField: 'fileName', caption: this.$t('enquiriesAttachments.fileName') });
      this.AttachmentsCols.push({ dataField: 'type', caption: this.$t('enquiriesAttachments.type') });
      this.AttachmentsCols.push({ dataField: 'comment', caption: this.$t('enquiriesAttachments.comment') });
      this.AttachmentsCols.push({ dataField: 'stampUser', caption: this.$t('enquiriesAttachments.stampUser') });
      this.AttachmentsCols.push({ dataField: 'stampDateTime', caption: this.$t('enquiriesAttachments.stampDateTime'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
    },
    attachmentsPageChange(pInfo) {
      this.attachmentsPageingOptions.page = pInfo.pageNumber;
      this.attachmentsPageingOptions.pageSize = pInfo.pageSize;
      this.getData();
    },

    itemSelected(item) {
      //console.log("udud", item.data)
    }
  },
}

